import React, { useRef, useState } from "react";
import "./ConseilsCreation.scss";
import { Controller, useForm } from "react-hook-form";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import Margin from "Components/Stats/Margin";
import axios from "axios";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { updateRessources } from "Redux/Actions/ressourcesActions";

const ConseilsCreation = (props) => {
  // Constantes comprenant les données du formulaire de création d'un conseil
  const defaultValues = {
    title: "",
    file: undefined,
    fileName: "",
  };

  const uploadOptions = {
    label: " ",
    icon: "pi pi-check",
    className: "bouton_valider",
  };
  const cancelOptions = {
    label: " ",
    icon: "pi pi-times",
    className: "bouton_supprimer",
  };

  const uploadToast = useRef(null);
  const cancelToast = useRef(null);

  // const [formData, setFormData] = useState("");
  const [file, setFile] = useState(undefined);
  const [, setFileName] = useState("");

  // useEffect(() => {
  //   if (formData !== "") postForm(formData);
  // }, [formData]);

  const uploadHandler = ({ files }) => {
    const file = files[0];
    const fileReader = new FileReader();
    setFile(file);
    fileReader.onload = () => {
      // setFile(e.target.result);
      setFileName(file.name);
    };
    fileReader.readAsDataURL(file);
    uploadToast.current.show({
      severity: "success",
      summary: "Succès : ",
      detail: "Le fichier " + file.name + " a bien été téléchargé",
      life: 3000,
    });
  };

  // messages du formulaire
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ defaultValues });

  const onSubmit = (data) => {
    setFields(data);
  };
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const setFields = (data) => {
    const setedData = {
      name: data.title,
      documentFile: file,
    };
    // data.file = file;
    // data.fileName = fileName;
    if (setedData.documentFile != null) {
      postForm(setedData);
    } else {
      cancelToast.current.show({
        severity: "error",
        summary: "Suppression : ",
        detail: "Aucun fichier n'a été selectionné ou validé",
        sticky: true,
      });
    }
  };
  const postForm = (data) => {
    // Variable qui stockera la réponse du serveur
    let response = null;
    // On crée un FormData qui sera envoyé au serveur
    var dataForm = new FormData();
    // On ajoute les données du formulaire au formData
    for (var key in data) dataForm.append(key, data[key]);

    let url = `${process.env.REACT_APP_BASE_URL_API}${"/resources/create"}`;
    // On envoie le formData au serveur
    axios
      .post(url, dataForm, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        response = res;
        uploadToast.current.show({
          severity: "success",
          summary: "Succès : ",
          detail: "La ressource a été créée",
          life: 3000,
        });
        props.handleUpdateRessources({
          ressourcesData: props.ressources.ressourcesData.concat(response.data),
        });
      })
      .catch((error) =>
        props.auth.toast.current.show({
          severity: "error",
          summary: "Erreur : ",
          detail:
            error?.response?.data?.detail ||
            "Une erreur est survenue lors de la création de la ressource",
          life: 5000,
        })
      )
      // Si tout s'est bien passé, on reset le formulaire
      .finally(() => {
        if (response) {
          reset();
        }
      });
  };

  return (
    <div className="conseil_formulaire">
      <Toast ref={uploadToast} />
      <Toast ref={cancelToast} />
      <div className="conseil_formulaire__container">
        <h3 className="attribuerDroits__title">
          Déposer des ressources et guides
        </h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="top_conseil">
            <div className="title_conseil">
              <h2
                htmlFor="title"
                className={classNames({ "p-error": errors.title })}
              >
                Titre du conseil *
              </h2>
              <Controller
                name="title"
                control={control}
                rules={{ required: "Le titre est requis" }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    placeholder="Comment rédiger son CV"
                    autoFocus
                    className={
                      (classNames({
                        "p-invalid": fieldState.invalid,
                      }),
                      "input_actu")
                    }
                  />
                )}
              />
              {getFormErrorMessage("title")}
            </div>
          </div>

          <div className="chargement_image">
            <div className="chargement_image__container">
              <div className="chargement_image__container__item">
                <h2
                  htmlFor="file"
                  className={classNames({ "p-error": errors.file })}
                >
                  Charger un fichier *
                </h2>
                <FileUpload
                  name="file"
                  customUpload={true}
                  uploadOptions={uploadOptions}
                  cancelOptions={cancelOptions}
                  uploadHandler={uploadHandler}
                  chooseLabel="Choisir un fichier PDF à télécharger"
                  onClear={() => {
                    setFile(undefined);
                    cancelToast.current.show({
                      severity: "error",
                      summary: "Suppression : ",
                      detail: "Le fichier a bien été supprimé",
                      life: 3000,
                    });
                  }}
                  accept="application/pdf"
                  maxFileSize={1000000}
                ></FileUpload>
              </div>
            </div>
          </div>

          <Margin position="bottom" size="xxs" />

          <div className="image_conseil__buttons"></div>
          <div className="buttons_bottom">
            <button className="btn-bleu publier_button" type="Submit">
              Déposer mon document
            </button>
            <button
              className="btn-blanc annuler_button"
              onClick={() => {
                reset({
                  title: "",
                  file: undefined,
                  fileName: "",
                });
                setFile(undefined);
                setFileName("");
              }}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
ConseilsCreation.propTypes = {
  auth: PropTypes.object,
  handleUpdateRessources: PropTypes.object,
  ressources: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  ressources: state.ressources,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateRessources: (value) => {
    dispatch(updateRessources(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConseilsCreation);
